<!--
 * @Author:
 * @LastEditTime: 2022-04-28 16:32:46
 * @Description:
-->
<template>
  <el-card class="h-full">
    <div class="flex mb-20px">
      <el-input
        size="mini"
        clearable
        placeholder="请输入关键字"
        class="!w-280px mr-10px"
        v-model="keyWord"
      />
      <el-button size="small" class="ml-0px mr-10px" type="primary" @click="searchList()"
        >搜索</el-button
      >
      <el-button size="small" class="!ml-0px mr-10px" type="primary" @click="addClient()"
        >新增</el-button
      >
    </div>
    <el-table
      stripe
      ref="eltable"
      :height="tableHeight"
      border
      :data="tableData"
      @sort-change="sortChangeTable"
    >
      <el-table-column label="名称" prop="clientId" sortable></el-table-column>
      <el-table-column label="显示名称" prop="clientName" sortable></el-table-column>
      <el-table-column label="是否允许刷新令牌" width="170px" prop="allowOfflineAccess" sortable>
        <template slot-scope="scope">
          {{ scope.row.allowOfflineAccess ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="启用" prop="enabled" sortable width="80px">
        <template slot-scope="scope">
          {{ scope.row.enabled ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column width="250px" show-overflow-tooltip label="操作">
        <template slot-scope="scope">
          <el-button @click="editClient(scope.row)" size="mini">修改</el-button>
          <el-button @click="editPermission(scope.row)" size="mini">权限配置</el-button>
          <el-button size="mini" @click="deleteClient(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right mt-20px"
      background
      @size-change="searchList()"
      @current-change="findList()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :pager-count="5"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
    <operate-client-dialog
      @refreshList="findList"
      v-if="showOperateClientDialog"
      :operateClientProps="operateClientProps"
      :clientForm="clientForm"
    ></operate-client-dialog>
    <operate-permission-dialog
      v-if="showPermissionDialog"
      :permissionProps="permissionProps"
    ></operate-permission-dialog>
  </el-card>
</template>

<script>
import { ClientApi } from '@wiz-api/auth-server'

const clientApi = new ClientApi()

const OperateClientDialog = () => {
  return import('../components/client/OperateClientDialog')
}
const operatePermissionDialog = () => {
  return import('../components/OperatePermissionDialog')
}
export default {
  name: 'client',
  components: {
    OperateClientDialog,
    operatePermissionDialog,
  },
  data() {
    return {
      showPermissionDialog: false,
      operateClientProps: {
        visible: true,
        title: '新增客户端',
        editType: 'create',
      },
      permissionProps: {
        visible: true,
        providerKey: '',
        providerName: 'C',
        title: '操作用户权限',
      },
      clientForm: {
        enabled: true,
        clientName: '',
        clientUri: '',
        logoUri: '',
        description: '',
        allowedScopes: ['email', 'openid', 'profile', 'role', 'phone', 'address'], // 默认
        allowedGrantTypes: [],
        redirectUris: [],
        postLogoutRedirectUris: [],
        allowOfflineAccess: false,
        identityTokenLifetime: 300, // 默认值
        accessTokenLifetime: 3600, // 默认值
        authorizationCodeLifetime: 300, // 默认值
        absoluteRefreshTokenLifetime: 2592000, // 默认值
        slidingRefreshTokenLifetime: 1296000, // 默认值
        refreshTokenUsage: 1, // 默认值
        refreshTokenExpiration: 1, // 默认值
        enableLocalLogin: true, // 默认true
        clientId: '',
        clientSecrets: [],
        allowAccessTokensViaBrowser: false,
        requireClientSecret: true,
        requirePkce: true,
        userSsoLifetime: null,
        claims: [],
      },
      showOperateClientDialog: false,
      keyWord: '',
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      sort: {
        type: '',
        sortName: 'creationTime',
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },

  methods: {
    /**
     * @description: 删除client
     * @param {*}
     * @return {*}
     */
    deleteClient(id) {
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await clientApi.callDelete(id)

          if (!err) {
            this.$message.success({
              showClose: true,
              message: '删除成功',
            })
            this.searchList()
          }
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    /**
     * @description: 修改用户权限
     * @param {*} row
     * @return {*}
     */
    editPermission(row) {
      this.showPermissionDialog = true
      this.permissionProps = this.$options.data().permissionProps
      this.$set(this.permissionProps, 'providerKey', row.clientId)
    },
    addClient() {
      this.showOperateClientDialog = true
      this.operateClientProps = this.$options.data().operateClientProps
      this.clientForm = this.$options.data().clientForm
    },
    async editClient(row) {
      const [err, res] = await clientApi.get(row.id)
      if (!err) {
        this.clientForm = res
        this.clientForm.redirectUris = _.map(res.redirectUris, (item) => {
          return {
            url: item,
          }
        })
        this.clientForm.postLogoutRedirectUris = _.map(res.postLogoutRedirectUris, (item) => {
          return {
            url: item,
          }
        })
      }
      this.showOperateClientDialog = true
      this.operateClientProps = this.$options.data().operateClientProps
      this.operateClientProps.editType = 'edit'
      this.operateClientProps.title = '编辑客户端'
    },
    sortChangeTable(sortColumn) {
      if (_.isNil(sortColumn.column)) {
        return
      }
      this.sort.type = sortColumn.order === 'ascending' ? 0 : 1
      this.sort.sortName = sortColumn.prop
      this.findList()
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      const [err, res] = await clientApi.getList({
        filter: this.keyWord,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        sorting: `${this.sort.sortName} ${this.sort.type === 0 ? 'asc' : 'desc'}`,
      })
      if (!err) {
        this.tableData = res.items
        this.page.pageTotal = res.totalCount
      }
    },
  },
  async created() {
    this.searchList()
  },
  activated() {
    this.$nextTick(() => {
      this.$refs.eltable.doLayout()
    })
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
